import { ref } from 'vue';
export const useFontChanger = () => {
    const index = ref(0);
    const fonts = [
        'Noto Serif JP, serif',
        'Hiragino Kaku Gothic Pro,メイリオ,Meiryo,ＭＳ Ｐゴシック,MS PGothic,sans-serif'
    ];
    const changeFont = (targetTextId) => {
        const element = document.getElementById(targetTextId);
        if (!element)
            throw new Error('Element not found');
        element.style.fontFamily = fonts[index.value];
        index.value++;
        if (index.value > fonts.length - 1) {
            index.value = 0;
        }
    };
    return {
        changeFont
    };
};
